import { render } from "./PushToSubZoneModal.vue?vue&type=template&id=a3c4ef12"
import script from "./PushToSubZoneModal.vue?vue&type=script&lang=js"
export * from "./PushToSubZoneModal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__